import { restApi } from "@redux/restApi";

interface UploadBulkQuotesPayload {
  file: File;
}

export const bulkQuotesRestApi = restApi.injectEndpoints({
  endpoints: (build) => ({
    uploadBulkQuotes: build.mutation<string, UploadBulkQuotesPayload>({
      query: ({ file }) => {
        const formData = new FormData();
        formData.append("files", file);

        return {
          url: `bulkQuotes`,
          method: "POST",
          mode: "cors",
          body: formData,
        };
      },
    }),
  }),
});

export const { useUploadBulkQuotesMutation } = bulkQuotesRestApi;
